import { RefreshCw, Trash2 } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "../ui/sheet";
import { AudioCell } from "../AudioCell";
import { RatingBadge } from "./FeedbackTable";
import { StatusControl } from "../ResolveDialog";
import { SENTIMENT_STYLE, fmtDate } from "../../lib/constants";

const Row = ({ label, children }) => (
  <div className="py-3 border-b border-emerald-900/5">
    <div className="field-label">{label}</div>
    <div className="mt-1 text-sm text-emerald-950">{children}</div>
  </div>
);

export const FeedbackDetail = ({ item, onClose, onResolve, onReopen, onReprocess, onDelete }) => (
  <Sheet open={!!item} onOpenChange={(o) => { if (!o) onClose(); }}>
    <SheetContent className="w-full sm:max-w-lg bg-white/95 backdrop-blur-xl overflow-y-auto" data-testid="feedback-detail-sheet">
      {item && (
        <>
          <SheetHeader>
            <SheetTitle className="font-display text-2xl font-extrabold text-emerald-950">{item.guest_name}</SheetTitle>
            <SheetDescription>{item.hotel} · {item.category} · {fmtDate(item.visit_date)}</SheetDescription>
          </SheetHeader>
          <div className="mt-4">
            <Row label="Rating"><RatingBadge r={item.rating} /></Row>
            <Row label="Mobile">{item.mobile || "—"}</Row>
            <Row label="Status"><StatusControl item={item} onResolve={onResolve} onReopen={onReopen} testId="detail-status" /></Row>
            {item.status === "Resolved" && item.resolution_remarks && (
              <Row label="Resolution remarks"><p className="whitespace-pre-wrap" data-testid="detail-resolution-remarks">{item.resolution_remarks}</p><p className="mt-1 text-xs text-slate-500">by {item.resolved_by_name}{item.resolved_at ? ` · ${new Date(item.resolved_at).toLocaleString("en-IN")}` : ""}</p></Row>
            )}
            <Row label="Audio recording"><AudioCell id={item.id} audio={item.audio} testId="detail-audio-play" />{item.audio && <div className="mt-1 text-xs text-slate-500">{item.audio.filename}</div>}</Row>
            <Row label="AI sentiment & topics">
              <div className="flex flex-wrap gap-1">
                <span className={`rounded-full border px-2 py-0.5 text-xs font-semibold ${SENTIMENT_STYLE[item.sentiment]}`} data-testid="detail-sentiment">{item.sentiment}</span>
                {item.topics.map((t) => <span key={t} className="rounded-full bg-slate-100 px-2 py-0.5 text-xs">{t}</span>)}
              </div>
            </Row>
            <Row label="AI summary"><span data-testid="detail-ai-summary">{item.ai_summary || (item.ai_status === "pending" ? "Processing…" : "—")}</span></Row>
            <Row label="Audio transcription"><p className="italic text-slate-600 whitespace-pre-wrap" data-testid="detail-transcript">{item.transcript || "—"}</p></Row>
            <Row label="Remarks"><p className="whitespace-pre-wrap">{item.remarks || "—"}</p></Row>
            <Row label="Taken by">{item.created_by_name || "—"}</Row>
          </div>
          <button data-testid="detail-reprocess-button" onClick={() => onReprocess(item.id)} disabled={item.ai_status === "pending"} className="mt-6 w-full h-11 rounded-full border border-emerald-900/20 text-emerald-900 font-semibold hover:bg-emerald-50 flex items-center justify-center gap-2 transition-colors disabled:opacity-50">
            <RefreshCw className="h-4 w-4" /> Re-run AI transcription & analysis
          </button>
          <button data-testid="detail-delete-button" onClick={() => onDelete(item)} className="mt-3 w-full h-11 rounded-full border border-red-200 text-red-600 font-semibold hover:bg-red-50 flex items-center justify-center gap-2 transition-colors">
            <Trash2 className="h-4 w-4" /> Delete feedback
          </button>
        </>
      )}
    </SheetContent>
  </Sheet>
);
